import React, { useMemo, useState } from 'react'
import classNames from 'classnames'
import classes from './BeneficiaryProfile.module.css'
import SettingsWrapper from '../SettingsWrapper'
import {
    FormInput,
    FormTextArea,
    ValidatedFormInput,
    ValidatedFormTextArea,
} from '../../../components/Form/Inputs/Inputs'
import { Button } from '../../../components/Button/Button'
import { Dropzone } from '../../../components/Form/Dropzone/Dropzone'
import {
    ReactComponent as PencilIcon,
    ReactComponent as EditIcon,
} from '../../../assets/icons/pencil.svg'
import { ReactComponent as CheckIcon } from '../../../assets/icons/check.svg'
import { useEffect } from 'react'
import { ProfileSchema } from '../../../util/formSchemas'
import { Formik } from 'formik'
import { useDispatch, useSelector } from 'react-redux'
import { userActions, userSelectors } from '../../../redux/userSlice'
import notification from '../../../components/Notification/notification'
import { updateUser } from '../../../api/profileApi'
import { profileActions, profileSelectors } from '../../../redux/profileSlice'
import useProfileForm from '../../../hooks/useProfileForm'
import userAvatar from '../../../assets/images/avatar-dark.svg'

const EmailInput = ({ email, onChange }) => {
    const [value, setValue] = useState(email)
    const [editing, setEditing] = useState(false)
    const handleSubmit = event => {
        event.preventDefault()
        onChange(email)
    }
    useEffect(() => {
        setValue(email)
    }, [email])
    return (
        <form className={classes.emailInputWrapper} onSubmit={handleSubmit}>
            {!editing && (
                <p className={classes.emailInputText}>
                    Your email is{' '}
                    <span className={classes.emailEmphasis}>{value}</span>
                </p>
            )}
            {editing && (
                <input
                    type="email"
                    className={classes.emailInput}
                    value={value}
                    onChange={e => setValue(e.target.value)}
                    aria-label="Email address"
                    id="email-address"
                    required
                />
            )}
            <button
                type={editing ? 'submit' : 'button'}
                className={classes.emailInputButton}
                onClick={() => setEditing(!editing)}
            >
                {editing ? <CheckIcon /> : <EditIcon />}
            </button>
        </form>
    )
}

const BeneficiaryProfile = () => {
    const user = useSelector(userSelectors.userDetails)

    const [dp, setDp] = useState(null)

    const fileURL = useMemo(() => dp && URL.createObjectURL(dp), [dp])

    const setDpHelper = newDp => {
        if (dp) {
            URL.revokeObjectURL(dp)
        }

        setDp(newDp)
    }

    const updateDetails = useProfileForm()

    return (
        <SettingsWrapper title="Profile">
            <Formik
                initialValues={{
                    firstname: user.firstname,
                    lastname: user.lastname,
                    bio: user.bio,
                }}
                validationSchema={ProfileSchema}
                onSubmit={values => updateDetails(values, dp)}
            >
                {({ handleSubmit }) => (
                    <>
                        <div
                            className={classNames(
                                classes.formRow,
                                classes.formRowDual
                            )}
                        >
                            <ValidatedFormInput
                                label={'First Name'}
                                name={'firstname'}
                                id={'firstname'}
                            />
                            <ValidatedFormInput
                                label={'Last Name'}
                                name={'lastname'}
                                id={'lastname'}
                            />
                        </div>
                        <ValidatedFormTextArea
                            label={'Brief Bio'}
                            className={classes.textArea}
                            name={'bio'}
                            id={'bio'}
                        />
                        <div className={classes.dropzone}>
                            <span className={classes.label}>
                                Profile Picture
                            </span>
                            <Dropzone
                                acceptedFileTypes={['image/jpeg', 'image/png']}
                                onChooseFile={setDpHelper}
                                sizeLimit={3}
                                defaultSrc={userAvatar}
                            />
                            {dp && (
                                <img
                                    src={fileURL}
                                    alt="Preview Dp"
                                    className={classes.imagePreview}
                                />
                            )}
                        </div>
                        <span className={classes.splitLine} />
                        <Button onClick={handleSubmit}>Save Changes</Button>
                    </>
                )}
            </Formik>
        </SettingsWrapper>
    )
}

export default BeneficiaryProfile
